import { render, staticRenderFns } from "./organisationUnit.vue?vue&type=template&id=20519480&scoped=true&"
import script from "./organisationUnit.vue?vue&type=script&lang=js&"
export * from "./organisationUnit.vue?vue&type=script&lang=js&"
import style0 from "./organisationUnit.vue?vue&type=style&index=0&id=20519480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20519480",
  null
  
)

export default component.exports